import { render, staticRenderFns } from "./DialogAlertSuccess.vue?vue&type=template&id=c25562aa&scoped=true&"
import script from "./DialogAlertSuccess.vue?vue&type=script&lang=js&"
export * from "./DialogAlertSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DialogAlertSuccess.vue?vue&type=style&index=0&id=c25562aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25562aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VDialog,VRow})
